export default __webpack_public_path__ + "static/media/cs1.f5f82ab4.JPG";